import React from 'react'
import {
  Row,
  Col,
  Modal,
  Button,
  Form,
  FormControl,
  InputGroup,
} from 'react-bootstrap'

import Select from 'components/Select'
import { ProjectCheckbox } from '../../PatientRegister/components'

const MockRow = ({ label, children, labelClassName = '' }) => (
  <Row className="mb-2">
    <Col
      xs={12}
      md={3}
      className={'text-md-right mt-2 ' + labelClassName}
    >
      {label}
    </Col>
    <Col xs={12} md={9}>
      {children}
    </Col>
  </Row>
)

const ConfigurableRow = ({
  fieldKey,
  label,
  config,
  onVisibilityChange,
  children,
}) => {
  const visible = config?.[fieldKey] === true

  return (
    <Row className="mb-2">
      <Col xs={12} md={3} className="text-md-right mt-2">
        <div className="d-flex align-items-center justify-content-md-end">
          <ProjectCheckbox
            ariaLabel={'แสดง ' + label}
            checked={visible}
            className="mb-0 mr-2"
            onChange={(checked) =>
              onVisibilityChange(fieldKey, checked)
            }
            onClick={(event) => event.stopPropagation()}
            title={'แสดง ' + label}
          />
          <span>{label}</span>
        </div>
      </Col>
      <Col xs={12} md={9} style={{ opacity: visible ? 1 : 0.45 }}>
        {children}
      </Col>
    </Row>
  )
}

const MockPlusButton = () => (
  <Button disabled style={{ height: 42, width: 46 }} variant="outline-primary">
    <i className="fas fa-plus" />
  </Button>
)

const AppointmentUiConfigModal = ({
  show,
  onHide,
  config,
  onConfigChange,
  onSave,
  loading,
  saving,
}) => {
  const setVisibility = (fieldKey, visible) => {
    onConfigChange((current) => ({
      ...current,
      [fieldKey]: visible,
    }))
  }

  const setDefaultDuration = (event) => {
    const value = event.target.value

    onConfigChange((current) => ({
      ...current,
      defaultDuration: value === '' ? null : Number(value),
    }))
  }

  return (
    <Modal show={show} onHide={onHide} size="xl" centered scrollable>
      <Modal.Header closeButton>
        <div>
          <Modal.Title>จองนัดหมายแพทย์ นาย alex thompson</Modal.Title>
          <small className="text-muted">
            ตั้งค่าช่องที่ต้องการแสดงในฟอร์มจองนัดหมาย
          </small>
        </div>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="py-5 text-center text-muted">
            กำลังโหลดการตั้งค่า...
          </div>
        ) : (
          <div className="mx-auto py-2" style={{ maxWidth: 850 }}>
            <MockRow label="Default duration">
              <InputGroup style={{ maxWidth: 220 }}>
                <FormControl
                  aria-label="Default duration (นาที)"
                  min="1"
                  onChange={setDefaultDuration}
                  placeholder="จำนวนนาที"
                  step="1"
                  type="number"
                  value={config?.defaultDuration ?? ''}
                />
                <InputGroup.Append>
                  <InputGroup.Text>นาที</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <small className="text-muted">
                ใช้เป็นระยะเวลาเริ่มต้นเมื่อสร้างนัดหมายใหม่
                เว้นว่างหากไม่ต้องการกำหนดค่าเริ่มต้น
              </small>
            </MockRow>

            <MockRow label="วันนัด">
              <div className="d-flex flex-wrap">
                <FormControl
                  className="mr-2 mb-1"
                  readOnly
                  style={{ maxWidth: 190 }}
                  value="03/08/2569"
                />
                <Button className="mr-2 mb-1" disabled variant="outline-secondary">
                  <i className="far fa-calendar-alt" />
                </Button>
                <FormControl
                  className="mr-2 mb-1"
                  readOnly
                  style={{ maxWidth: 130 }}
                  value="00:00"
                />
                <FormControl
                  className="mb-1"
                  readOnly
                  style={{ maxWidth: 140 }}
                  value={
                    config?.defaultDuration
                      ? config.defaultDuration + ' นาที'
                      : 'ไม่กำหนด'
                  }
                />
              </div>
            </MockRow>

            <MockRow label="แพทย์">
              <FormControl readOnly value="516 - นาย alex thompson" />
              <div className="mt-2 text-danger">
                ไม่พบ slot ออกตรวจของแพทย์ในวันนี้
              </div>
            </MockRow>

            <MockRow label="HN">
              <InputGroup>
                <FormControl placeholder="HN" readOnly />
                <InputGroup.Append>
                  <Button disabled variant="primary">
                    <i className="feather icon-search" />
                  </Button>
                  <Button className="ml-1" disabled variant="outline-danger">
                    Clear
                  </Button>
                </InputGroup.Append>
              </InputGroup>
            </MockRow>

            <MockRow label="ผู้ถูกนัด/ผู้ป่วย">
              <InputGroup>
                <FormControl placeholder="ชื่อผู้ถูกนัด/ผู้ป่วย" readOnly />
                <InputGroup.Append>
                  <Button disabled variant="primary">
                    <i className="feather icon-search" />
                  </Button>
                </InputGroup.Append>
              </InputGroup>
            </MockRow>

            <MockRow label="เบอร์ติดต่อ">
              <FormControl placeholder="เบอร์ติดต่อ" readOnly />
            </MockRow>

            <ConfigurableRow
              config={config}
              fieldKey="appointmentType"
              label="ประเภทการนัด"
              onVisibilityChange={setVisibility}
            >
              <Select
                isDisabled
                options={[{ name: 'นัดตรวจ' }]}
                value={{ name: 'นัดตรวจ' }}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.name}
              />
            </ConfigurableRow>

            <ConfigurableRow
              config={config}
              fieldKey="specialtyCode"
              label="แผนก"
              onVisibilityChange={setVisibility}
            >
              <Select
                isDisabled
                options={[]}
                placeholder="แผนก"
                value={{ specialtyCode: '01', label: '01 - อายุรกรรม' }}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.specialtyCode}
              />
            </ConfigurableRow>

            <ConfigurableRow
              config={config}
              fieldKey="calendarServiceId"
              label="Service"
              onVisibilityChange={setVisibility}
            >
              <Select isDisabled options={[]} placeholder="Service" />
            </ConfigurableRow>

            <ConfigurableRow
              config={config}
              fieldKey="calendarLocationId"
              label="Room"
              onVisibilityChange={setVisibility}
            >
              <div className="d-flex">
                <div className="flex-grow-1 mr-2">
                  <Select isDisabled options={[]} placeholder="Room" />
                </div>
                <Button disabled variant="primary">
                  ลงนัดหมายห้อง
                </Button>
              </div>
            </ConfigurableRow>

            <ConfigurableRow
              config={config}
              fieldKey="generalNote"
              label="หมายเหตุ / note"
              onVisibilityChange={setVisibility}
            >
              <Form.Control
                as="textarea"
                placeholder="ลงหมายเหตุ"
                readOnly
                rows={2}
              />
            </ConfigurableRow>

            <ConfigurableRow
              config={config}
              fieldKey="operationalNote"
              label="การปฎิบัติตัว"
              onVisibilityChange={setVisibility}
            >
              <MockPlusButton />
            </ConfigurableRow>

            <ConfigurableRow
              config={config}
              fieldKey="labTestNote"
              label="LAB/ตรวจอื่น"
              onVisibilityChange={setVisibility}
            >
              <MockPlusButton />
            </ConfigurableRow>

            <ConfigurableRow
              config={config}
              fieldKey="radiologyTestNote"
              label="ตรวจวินิจฉัยพิเศษล่วงหน้า"
              onVisibilityChange={setVisibility}
            >
              <MockPlusButton />
            </ConfigurableRow>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={saving} onClick={onHide} variant="outline-danger">
          ปิด
        </Button>
        <Button disabled={loading || saving} onClick={onSave} variant="primary">
          {saving ? 'กำลังบันทึก...' : 'บันทึกการตั้งค่า'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AppointmentUiConfigModal
